import React from 'react'
import Icon from 'components/elements/Icon'

import styles from './backButton.module.scss'

type BackButtonProps = {
  onBack?: () => void
  children?: React.ReactNode
  mobileClassName?: string
  className?: string
}

export const BackButton = ({ onBack, children, mobileClassName = '', className = '' }: BackButtonProps) => (
  <>
    {/* CSS hidden on desktop */}
    <div className={`${styles.mobileBar} ${mobileClassName}`}>
      <div className={`${styles.mobileBarContent} ${className}`}>
        <button onClick={onBack}>
          <Icon name="arrow left" />
          <span>Back</span>
        </button>
        {children}
      </div>
    </div>

    {/* CSS hidden on mobile */}
    <div className={styles.desktopBar}>
      <button onClick={onBack} className={`${styles.backButton} ${className}`}>
        <Icon name="arrow left" />
        <span>Back</span>
      </button>
      {children}
    </div>
  </>
)

export default BackButton
